<template>
  <div class="register-wrap">
    <member-link-site-info :member_link="member_link" @updateSiteInfo="updateSiteInfo" />
    <authLeft v-if="$mq != 'sp' && $mq != 'tb'" />
    <div class="register-right">
      <div class="register-form">
        <div class="register-form-title" v-if="!expired && !limited">{{ siteName }} へようこそ！</div>
        <div style="margin-top:160px" v-loading="!mounted" v-if="!mounted"></div>
        <div v-if="mounted && !expired && !limited">
          <div class="register-form-subtitle" style="margin-bottom:30px">
            <el-image :src="client_data.img_url" class="header-logo dropdown">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['fas', 'building']" />
              </div>
            </el-image>
            <span style="font-weight:700; margin-right:5px">{{ client_data.client_name }}</span>
            のメンバーアカウントを作成
          </div>

          <el-form v-if="nomember || next_step" :model="form" :rules="rules" ref="form" @submit.native.prevent="register">
            <div class="register-form-subtitle">担当者名<span style="color:red; margin-left:3px">*</span></div>
            <el-form-item prop="person_name">
              <el-input placeholder="担当者名" v-model="form.person_name" :disabled="select_index > -1"></el-input>
            </el-form-item>
            <div class="register-form-subtitle">部署・役職<span style="color:red; margin-left:3px">*</span></div>
            <el-form-item prop="position">
              <el-input placeholder="部署・役職名" v-model="form.position"></el-input>
            </el-form-item>
            <div class="register-form-subtitle">メールアドレス<span style="color:red; margin-left:3px">*</span></div>
            <el-form-item prop="email">
              <el-input :placeholder="client_data.auth_domain_str + 'のメールアドレスを入力'" v-model="form.email"></el-input>
            </el-form-item>
            <div class="register-form-subtitle">パスワード<span style="color:red; margin-left:3px">*</span></div>
            <el-form-item prop="pass">
              <el-input placeholder="パスワード" v-model="form.pass" type="password" autocomplete="new-password" show-password></el-input>
            </el-form-item>
            <el-button style="width:100%; margin-top:10px;" type="primary" native-type="submit" :disabled="!consent || loading">
              <div class="flex-row">
                アカウント登録
                <div class="loader--mini" v-show="loading"></div>
              </div>
            </el-button>
            <div class="register-form-subtitle">
              <el-checkbox v-model="consent"></el-checkbox>
              <span style="margin-left:10px; font-size:11px; color:#999">
                <a :href=termsOfUseUrl target="_blank" style="color:#0095f6">利用規約</a>
                に同意して登録する</span
              >
            </div>
            <div v-show="!nomember" class="register-member-back" @click="next_step = false">
              <font-awesome-icon :icon="['far', 'arrow-left']" style="margin-right: 3px;" />
              前の画面に戻る
            </div>
          </el-form>

          <el-form v-if="!nomember && !next_step" @submit.native.prevent="next()">
            <div class="register-member-select-wrap" :class="radio == 'exist' ? 'focus' : ''" @click.self="radio = 'exist'">
              <el-radio v-model="radio" label="exist">既に登録されているメンバーを選択してアカウント作成 </el-radio>
              <el-input v-if="client_data.member.length >= 5" size="small" style="margin-top:15px" v-model="member_search" class="member-search" placeholder="メンバー検索" clearable></el-input>
              <div class="register-member-wrap">
                <div v-for="(member, index) in member_list" :key="member.id" @click="selectMember(member, index)">
                  <div class="register-member-person">
                    <el-image :src="member.img_url" class="setting-member-profile mini setting pointer">
                      <div slot="error" class="setting-member-noimg small setting">{{ member.value | firstLetter }}</div>
                    </el-image>
                    <div style="margin-left: 10px;">{{ member.value }}</div>
                    <div class="flex-space"></div>
                    <div v-if="select_index == index">
                      <font-awesome-icon :icon="['fas', 'check-circle']" style="color:#0095f6; font-size:16px" />
                    </div>
                  </div>
                </div>
                <div v-if="member_list.length == 0" class="register-member-noexist">該当するメンバーは存在しません</div>
              </div>
              <div v-if="radio == 'exist' && select_index < 0" class="register-member-select-alert">
                <div class="flex-space"></div>
                メンバーを選択してください
              </div>
            </div>
            <div class="register-member-select-wrap" :class="radio == 'new' ? 'focus' : ''" @click="newMember()">
              <el-radio v-model="radio" label="new">新規メンバーとしてアカウント作成</el-radio>
            </div>
            <div class="register-form-subtitle bottom">
              <el-button style="width:100%; margin-top:10px;" type="primary" native-type="submit" :disabled="is_not_fill">次へ</el-button>
            </div>
          </el-form>
        </div>
        <div class="data-table-list-nolist" v-if="expired">
          <img src="../../assets/time.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:900; margin-bottom:10px;">この招待リンクは有効期限が切れています</div>
          <div style="margin-bottom: 30px;">
            アカウント管理者に再度招待リンクの発行を依頼してください。
          </div>
        </div>
        <div class="data-table-list-nolist" v-if="limited">
          <img src="../../assets/time.png" style="opacity:0.5" alt />
          <div style="font-size:20px; font-weight:900; margin-bottom:10px;">登録メンバーが上限数に達しています</div>
          <div style="margin-bottom: 30px;">
            アカウント管理者にご確認ください。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
import MemberLinkSiteInfo from "@/components/oem/MemberLinkSiteInfo.vue";

const root = process.env.VUE_APP_API;
const loadMemberLinkAPI = root + "/api/member/load_member_link";
const emailValidateAPI = root + "/api/auth/emailvalidate";
const memberAuthAPI = root + "/api/auth/auth_member";

export default {
  name: "memberInvite",
  components: {
    authLeft,
    MemberLinkSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      var m = value.match(/@([a-zA-Z0-9._-]*)/);
      for (let i = 0; i < this.client_data.auth_domain.length; i++) {
        if (m[1] == this.client_data.auth_domain[i]) var match = true;
      }
      if (match) {
        callback();
      } else {
        callback(new Error(this.client_data.auth_domain_str + "以外のドメインメールアドレスはご利用いただけません"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        callback();
      }
    };
    return {
      member_link: this.$route.params.member_link,
      mounted: false,
      loading: false,
      radio: "exist",
      member_search: "",
      select_index: -1,
      token: "",
      termsOfUseUrl: "https://reech.co.jp/term/",
      form: {
        person_id: "",
        person_name: "",
        position: "",
        email: "",
        pass: "",
        checkPass: "",
      },
      client_data: [],
      nomember: false,
      next_step: false,
      consent: true,
      expired: false,
      limited: false,
      rules: {
        person_name: [{ required: true, message: "担当者名は必須です", trigger: "change" }],
        position: [{ required: true, message: "部署・役職名は必須です", trigger: "change" }],
        email: [
          {
            required: true,
            message: "メールアドレスは必須です",
            trigger: "change",
          },
          { type: "email", message: "不正なメールアドレス形式です", trigger: "change" },
          { validator: validateEmail, trigger: "change" },
        ],
        pass: [
          {
            required: true,
            message: "パスワードは必須です",
            trigger: "change",
          },
          {
            min: 8,
            message: "パスワードは8文字以上で設定してください",
            trigger: "change",
          },
          { validator: validatePass, trigger: "change" },
        ],
      },
      siteName: "REECH DATABASE",
    };
  },
  computed: {
    member_list() {
      var member = this.client_data.member;
      var regexp = new RegExp(this.member_search, "ig");
      if (this.member_search) {
        var sort = [];
        for (let i = 0; i < member.length; i++) {
          if (member[i].value.match(regexp)) {
            sort.push(member[i]);
          }
        }
        return sort;
      } else {
        return member;
      }
    },
    is_not_fill() {
      if (this.radio == "exist" && this.select_index == -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.member_link = this.$route.params.member_link;
    this.loadMemberLink();
  },
  methods: {
    loadMemberLink() {
      var params = new URLSearchParams();
      params.append("member_link", this.member_link);
      this.axios
        .post(loadMemberLinkAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.client_data = response.data.client_data;
            if (this.client_data.member.length == 0) this.nomember = true;
          } else if (response.data.status == "expired") {
            this.expired = true;
          } else if (response.data.status == "limited") {
            this.limited = true;
          } else {
            this.$router.push("/404");
          }
          this.mounted = true;
        })
        .catch(() => {});
    },
    selectMember(member, index) {
      this.radio = "exist";
      this.form.person_id = member.person_id;
      this.form.person_name = member.value;
      this.select_index = index;
    },
    newMember() {
      this.radio = "new";
      this.form.person_id = "";
      this.form.person_name = "";
      this.select_index = -1;
    },
    next() {
      this.next_step = true;
    },
    register() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = new URLSearchParams();
          params.append("email", this.form.email);
          params.append("member_link", this.member_link);
          params.append("type", "member");
          this.axios.post(emailValidateAPI, params).then((response) => {
            if (response.data.status == "NG") {
              this.loading = false;
              this.$message.error(response.data.message);
            } else {
              firebase
                .auth()
                .createUserWithEmailAndPassword(this.form.email, this.form.pass)
                .then((authData) => {
                  var params = new URLSearchParams();
                  params.append("member_link", this.member_link);
                  params.append("person_id", this.form.person_id);
                  params.append("person_name", this.form.person_name);
                  params.append("position", this.form.position);
                  params.append("email", this.form.email);
                  params.append("pass", this.form.pass);
                  params.append("uid", authData.user.uid);
                  this.axios.post(memberAuthAPI, params).then((response) => {
                    if (response.data.status == "OK") {
                      var params = new URLSearchParams();
                      params.append("user_token", authData.user.uid);
                      params.append("type", "member");
                      this.$router.push({
                        path: "/confirm",
                        query: {
                          token: authData.user.uid,
                        },
                      });
                      this.loading = false;
                    } else {
                      this.$message({
                        type: "error",
                        offset: 7,
                        showClose: true,
                        message: "エラーが発生しました。しばらく時間を空けてお試しいただくか、担当者までご連絡ください。",
                      });
                      this.loading = false;}
                  });
                })
                .catch(() => {
                  this.$message.error("既に登録されているメールアドレスです");
                  this.loading = false;
                });
            }
          });
        } else {
          this.$message.error("項目を正しく入力してください");
          this.loading = false;
        }
      });
    },
    updateSiteInfo({siteName, termsOfUseUrl}) {
      this.siteName = siteName;
      this.termsOfUseUrl = termsOfUseUrl;
    },
  },
  watch: {},
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
